export default {
  locale: "es-MX"
  , nodata: "No hay opciones para seleccionar"
  , system: "ACH"
  , ok: "OK"
  , cancel: "Cancelar"
  , clear: "Limpiar"
  , desde: "Desde"
  , hasta: "Hasta"
  , clave: "Clave"
  , email: "Email"
  , reenviarEmail: "Reenviar Email"
  , status: "Estatus"
  , url: "URL"
  , usuario: "Usuario"
  , puerto: "Puerto"
  , directorio: "Directorio"
  , contrasena: "Contraseña"
  , audit: "Auditoría"
  , loading: "Cargando . . ."
  , save: "Guardar"
  , update: "Actualizar"
  , privileges: "Privilegios"
  , filtros: "Filtros de Búsqueda"
  , filtro: "Filtro"
  , fechaDesde: "Fecha Desde"
  , fechaHasta: "Fecha Hasta"
  , fecha: "Fecha"
  , dateIni: "Fecha Inicio"
  , dateEnd: "Fecha Fin"
  , monthIni: "Mes Inicio"
  , monthEnd: "Mes Fin"
  , yearIni: "Año Inicio"
  , yearEnd: "Año Fin"
  , aplicar: "Aplicar"
  , search: "Buscar"
  , proceso: "Proceso"
  , accion: "Acción"
  , detail: "Detalles"
  , edit: "Editar"
  , disable: "Desactivar"
  , delete: "Eliminar"
  , report: "Generar Reporte"
  , print: "Imprimir"
  , excel: "Descargar Excel"
  , records: "Registros"
  , add: "Agregar"
  , remove: "Quitar"
  , download: "Descargar Archivo"
  , upload: "Subir Archivo"
  , close: "Cerrar"
  , today: "Hoy"
  , back: "Regresar al listado"
  , yes: "Si"
  , no: "No"
  , select: "Seleccionar"
  , imgsel: "Selecciona una imagen"
  , imgrem: "Remover imagen"
  , imggal: "Galería de Imágenes"
  , expandAll: "Expandir todo"
  , colapseAll: "Contraer todo"
  , reload: "Recargar"
  , autoreload: "Auto Recarga"
  , maxregs: "El número de registros supera el limite permitido"
  , minregs: "No se encontraron registros"
  , minselregs: "No se seleccionaron registros"
  , errrep: "No se encontraron registros para reportar"
  , pais: "País"
  , tipo: "Tipo"
  , lada: "C.Area"
  , selected: "Registros seleccionados"
  , errors: "Descargar Errores"
  , filters: {
    title: "Filtros de Búsqueda"
    , select: "Selecciona un Filtro"
    , add: "Agregar Filtro"
    , clear: "Limpiar todos los filtros"
    , dateini: "Fecha Desde"
    , dateend: "Fecha Hasta"
    , periodini: "Periodo Desde"
    , periodend: "Periodo Hasta"
    , moneyini: "Monto Mínimo"
    , moneyend: "Monto Máximo"
    , yes: "Sí"
    , no: "No"
  }
  , filepond: {
    select: "Arrastra el archivo aquí o Selecciona un archivo"
    , labelFileLoading: "Cargando"
    , labelFileProcessing: "Subiendo"
    , labelFileProcessingComplete: "Carga completa"
    , labelTapToRetry: "Volver a intentar"
    , labelidle: "Arrastra el archivo aquí o <span class='filepond--label-action'> Selecciona archivo </span>"
    , labelInvalidField: "El tipo de archivo no es valido"
    , labelFileProcessingAborted: "Cancelar"
    , labelTapToCancel: "Cancelar"
    , labelFileLoadError: "Ocurrió un error, intente nuevamente o compruebe sus permisos"
    , labelFileProcessingError: "Ocurrió un error, verifique la información del archivo."
    , labelFileTypeNotAllowed: "Tipo de archivo inválido"
    , labelMaxFileSizeExceeded: "El archivo excede el tamaño máximo permitido"
    , labelMaxFileSize: "El tamaño máximo permitido es de {filesize}"
    , labelMaxFiles: "Se seleccionaron mas de {0} archivos"
    , labelNoPermission: "No cuentas con permisos para cargar archivos {0}"
    , labelNameCharacters: "El nombre no debe contener caracteres especiales"
    , labelNameMaxChars: "El nombre no debe contener mas de {0} caracteres"
    , fileValidateTypeLabelExpectedTypes: "Archivos válidos {0}"
  }
  , swal: {
    common: {
      confirmButtonColor: "#0077BC"
      , cancelButtonColor: "#e7eaec"
      , confirmButtonText: "Aceptar"
      , cancelButtonText: "Cancelar"
    }
    , delete: {
      title: "¿Está seguro?"
      , text: "Se eliminará el registro"
      , type: "warning"
    }
    , disable: {
      title: "¿Está seguro?"
      , text: "Se deshabilitará el registro"
      , type: "warning"
    }
    , clear: {
      title: "¿Está seguro?"
      , text: "No se guardarán los cambios"
      , type: "warning"
    }
    , logout: {
      title: "Cerrar Sesión"
      , text: "Puede mejorar la seguridad cerrando el navegador una vez que ha salido del sistema"
      , type: "warning"
    }
    , deleteProfile: {
      title: "¿Está seguro?"
      , text: "Se eliminarán los privilegios y usuarios asignados"
      , type: "warning"
    }
    , resetPassword: {
      title: "¿Está seguro?"
      , text: "Esta acción reseteará el password del usuario seleccionado"
      , type: "warning"
    }
    , massUpdateSwal: {
      title: "Update Masivo Completado"
      , type: "success"
      , html: ""
    }
    , emailSendSwal: {
      title: "Envío Masivo de Emails de Bases Completado"
      , type: "success"
      , html: ""
    }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/commons.js